export default "__VITE_ASSET__aoJJToay__"